wbApp.directive('wbCourseCategoryCombo', ['$timeout', '$translate', '$filter', 'courseCategorySvc',
    function ($timeout, $translate, $filter, courseCategorySvc) {
        function formatResult(model) {
            if (!model) { return; }

            return model.text;
        }

        function formatSelection(model) {
            if (model) {
                return model.text;
            }

            return "";
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {

                var courseCategories = _.orderBy(courseCategorySvc.getAll(), 'text');

                $timeout(function () {
                    $(elm).select2({
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                       // minimumResultsForSearch: -1,
                        id: function (courseCategory) { return courseCategory.courseCategoryID; },
                        data: courseCategories
                    });

                    ctrl.$render();
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return 0;
                    } else {
                        return parseInt(viewValue);
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return "";
                    } else {
                        return value + "";
                    }
                });

                ctrl.$render = function () {
                    $(elm).select2('val', ctrl.$viewValue);
                }

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);